import type { IGggFinanceProjectRow } from '../types';

export interface IFinanceProjectOrder {
  game_title: string;
  order: number;
}

export const getFinanceProjectOrderList = (
  projectList: IGggFinanceProjectRow[],
): IFinanceProjectOrder[] => {
  return [...(projectList || [])]
    .sort(
      (a, b) =>
        (Number(a?.order) || Number.MAX_SAFE_INTEGER) -
        (Number(b?.order) || Number.MAX_SAFE_INTEGER),
    )
    .map((project, index) => ({
      game_title: project?.game_title || '',
      order: project?.order ?? index + 1,
    }))
    .filter(item => item.game_title);
};
